<template>
  <v-container class="pa-0" align-content-start>
    <v-layout wrap>
      <v-flex id="currentDate" xs12>
        <v-expansion-panel v-model="datePanel" expand dark>
          <v-expansion-panel-content
            id="mobileFieldSelectedDate"
            :ripple="datePanel.length === 0 && allRoutesShowing"
            :readonly="datePanel.length !== 0 || !allRoutesShowing"
            hide-actions
          >
            <template v-slot:header>
              <slot name="dateLabel" :date="computedDateFormattedMomentjs" />
            </template>
            <v-card>
              <v-date-picker
                id="mobileDatePicker"
                :value="date"
                :events="calendarEventsArray"
                :event-color="scssColors.hwayzTeal"
                color="grey"
                light
                full-width
                no-title
                @input="$emit('date-clicked', $event)"
              >
                <slot name="pickerButtons" />
              </v-date-picker>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import colors from '../../scss/_colors.scss'

export default {
  props: {
    propDate: {
      type: String,
      required: true
    },
    calendarEventsArray: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  data() {
    return {
      datePanel: [],
      scssColors: colors
    }
  },

  computed: {
    ...mapState('common', ['profileStatus']),
    ...mapState('mobile', ['allRoutesShowing']),

    computedDateFormattedMomentjs() {
      return this.date ? moment(this.date).format('dddd, MMMM Do YYYY') : ''
    },

    date() {
      return this.propDate
    }
  },

  methods: {
    clearDate() {
      // this.date = new Date().toISOString().substr(0, 10)
      this.closeDatePanel()
    },

    closeDatePanel() {
      this.datePanel = []
    }
  }
}
</script>

<style lang="sass">
#currentDate
  .v-expansion-panel
    box-shadow: none
</style>
